// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__qzMPl","textarea":"styles_textarea__1c4hj"};